import {
  useCallback,
  useState,
  useMemo,
  useEffect,
  useRef,
  useLayoutEffect,
} from 'react'
import Header from './components/Header'
import Content from './components/Content'
import ReportModal from './components/Modals/ReportModal'
import HintModal from './components/Modals/HintModal'
import InfoModal from './components/Modals/InfoModal'
import FooterAfterResponse from './components/Footer/FooterAfterResponse'
import FooterBeforeResponse from './components/Footer/FooterBeforeResponse'
import FilterModal from './components/Modals/FilterModal'
import { CommentsSection } from './components/Comments'
import GrileService from '../../services/grile-service'
import { useMediaQuery } from 'react-responsive'
import swal from 'sweetalert'
import 'reactjs-popup/dist/index.css'
import '@liveblocks/react-comments/styles.css'
import GridsListModal from './components/Modals/GridsListModal'
import GridsNavigation from './components/GridsSidebar'
import {
  getChoicesClass,
  getCurrentDimension,
  getMaxChoiceLength,
  isAnswerCorrect,
} from '../../utils'
import ModalAfterSubmit from './components/Modals/ModalAfterSubmit'
import useGetFilters from '../../hooks/useGetAllTags'
import { useAuthContext } from '../../context'
import CustomTour from '../CustomTour'
import { useTourContext } from '../../context/TourContext'
import NoteModal from './components/Modals/NoteModal'
import Button from 'components/Button'

const Grid = ({
  hasHint,
  createGrid = false,
  isCreateSubject = false,
  showProgress = true,
  showSkeleton = true,
  isSubjectGenerated,
  setCurrentSubject,
  handleChangeChaptersByCourse,
  gridTags,
  isSubject,
  justStarted,
  isLoading,
  currentGrila,
  difficulty,
  handleGetRemainingTimeString,
  isGettingNextGrid,
  isMultipleChoice,
  hasSubscription,
  handleTagsCheckboxChange,
  source,
  updateFiltersInStorage,
  difficultyFilter,
  currentGridId,
  filteredTags,
  comments,
  handleUpdateGrid,
  handleSubmit,
  started,
  trialGrileCount,
  isAnswerSelected,
  isSubmitted,
  endTrial,
  checkbox,
  answer,
  setCheckbox,
  updateCommentsAfterAddingCommentCallback,
  handleUserGetHint,
  hint,
  handleStartNow,
  currentGridIndex,
  handleNextGrid,
  handlePrevGrid,
  handleCurrentGrid,
  gridsFromSubject = [],
  handleChangeAnswer,
  userChoice,
  handleNewSubjectWindow,
  height,
  setHeight,
  widthClass,
  isSkippingSubject,
  isSubmittingSubject,
  isSubmittingGrid,
  handleSelectDifficulty,
  explanationPreview,
  hintPreview,
  gridId,
  onSuccessCreateSubject,
  removeGrid,
  gridSubject,
  noMargin,
  subjectCreate = false,
  handleSaveGrid,
  handleRemoveSavedGrid,
  noteTextAreaRef,
  isGridSaved,
  allowHint = true,
  beginTimestamp = null,
  endTimestamp = null,
  solvingModes,
  handleChangeSolvingMode,
  grileTypes,
  handleChangeGrileTypes,
  pagesAuto,
  pagesManual,
  books,
  book,
  explainAnswers,
}) => {
  const [hintModalOpened, setHintModalOpened] = useState(false)
  const [infoModalOpened, setInfoModalOpened] = useState(false)
  const [reportModalOpened, setReportModalOpened] = useState(false)
  const [tourModalOpened, setTourModalOpened] = useState(false)
  const [filtersModalOpened, setFiltersModalOpened] = useState(false)
  const [gridsSidebarOpened, setGridsSidebarOpened] = useState(false)
  const [modalAfterSubmitOpened, setModalAfterSubmitOpened] = useState(answer)
  const [rated, setRated] = useState(false)
  const [textarea, setTextarea] = useState('')
  const [isReported, setIsReported] = useState(false)
  const { chapters } = useGetFilters()
  const [gridWidth, setGridWidth] = useState(0)
  const [maxChoiceLength, setMaxChoiceLength] = useState(0)
  const [screenSize, setScreenSize] = useState(getCurrentDimension())
  const { userDetails, setUserDetails } = useAuthContext()
  const { handleFocusTour, handleUnFocusTour, handleNextTourStep } =
    useTourContext()
  const ref = useRef(null)

  const grilaExplain = useMemo(
    () =>
      explanationPreview
        ? explanationPreview
        : !isSubject
          ? answer?.['explain']
          : answer?.['explain']?.[currentGridIndex],
    [answer, currentGridIndex, explanationPreview, isSubject],
  )

  const [isNoteModalOpened, setIsNoteModalOpened] = useState(false)

  const handleCloseNoteModal = () => {
    setIsNoteModalOpened(false)
  }

  const handleOpenNoteModal = () => {
    !isGridSaved && setIsNoteModalOpened(true)
  }

  const [localGridsFromSubject, setLocalGridsFromSubject] =
    useState(gridsFromSubject)

  const handleCloseGridsModal = useCallback(() => {
    setGridsSidebarOpened(false)
  }, [])

  const handleGridsSidebar = useCallback(() => {
    setGridsSidebarOpened(prev => !prev)
  }, [])

  // Hint Modal
  const handleOpenHintModal = useCallback(async () => {
    if (!hint) {
      await handleUserGetHint()
    }

    if (!userDetails?.tutorial) {
      handleUnFocusTour()
    }
    setHintModalOpened(o => !o)
  }, [hint, userDetails?.tutorial, handleUserGetHint, handleUnFocusTour])

  // Modal After Reponse
  const handleCloseModalAfterSubmit = () => setModalAfterSubmitOpened(false)
  const handleCloseHintModal = () => {
    setHintModalOpened(false)
    handleFocusTour()
  }
  // Report Modal
  const handleTextareaChange = event => {
    setTextarea(event.target.value)
  }
  // cpoomasd
  const handleReport = useCallback(async () => {
    const payload = { grilaId: currentGridId, reasons: '', description: '' }
    await GrileService.reportGrila(payload)
  }, [currentGridId])

  const closeModal = useCallback(() => {
    setTextarea('')
    setReportModalOpened(false)
    if (!userDetails?.tutorial) {
      handleFocusTour()
    }
  }, [userDetails?.tutorial, handleFocusTour])
  const handleOptionalReport = useCallback(async () => {
    const possibleReasons = ['Cerinta', 'Variante', 'Hint', 'Explicație']
    let reasonsText = ''

    for (let index = 0; index < checkbox?.length; index += 1) {
      if (checkbox[index] === true) {
        reasonsText += `${possibleReasons[index]}, `
      }
    }

    const payload = {
      grilaId: currentGridId,
      reasons: reasonsText,
      description: textarea,
    }
    await GrileService.reportGrila(payload)
    setIsReported(true)
  }, [checkbox, currentGridId, textarea])

  // Info Modal
  const handleCloseInfoModal = () => {
    setInfoModalOpened(false)
    if (!userDetails.tutorial) {
      handleFocusTour()
      handleNextTourStep()
    }
  }

  // Filter Modal
  const closeFilterSettings = () => {
    setFiltersModalOpened(false)
    handleFocusTour()
  }

  const isSmallDevice = useMediaQuery({
    query: '(max-width: 1280px)',
  })

  const formatTags = useCallback(() => {
    const formatTagsArray = []

    gridTags?.forEach(chapterIndex => {
      formatTagsArray?.push(
        chapters
          ?.filter(chapter => chapter.id === chapterIndex)
          .map(chapter => chapter.name),
      )
    })

    return formatTagsArray
  }, [chapters, gridTags])

  const numberOfAnsweredGrids = useMemo(() => {
    return gridsFromSubject?.reduce((acc, curr) => {
      if (curr?.choice !== null && !isNaN(curr?.choice) && 'choice' in curr) {
        return acc + 1
      }
      return acc
    }, 0)
  }, [gridsFromSubject])

  const handleRate = useCallback(
    async value => {
      if (isSubject) {
        const newGridsList = [...localGridsFromSubject]
        newGridsList[currentGridIndex].rated = true
        setLocalGridsFromSubject(newGridsList)
      }
      const payload = { grilaId: currentGridId, type: 0, rating: value }
      await GrileService.rate(payload)
      setRated(true)
      swal({
        title: 'Feedback trimis',
        text: 'Mulțumim!',
        icon: 'success',
        timer: '2000',
        buttons: false,
      })
    },
    [isSubject, currentGridId, localGridsFromSubject, currentGridIndex],
  )

  useEffect(() => {
    const localCurrentGrid = isSubject
      ? gridsFromSubject?.[currentGridIndex]?.json
      : currentGrila
    const newMaxChoiceLength = getMaxChoiceLength(localCurrentGrid)
    setMaxChoiceLength(newMaxChoiceLength)
  }, [isSubject, currentGridIndex, gridsFromSubject, currentGrila])

  useEffect(() => {
    const choicesContainer =
      document.getElementsByClassName('choices-container')

    if (choicesContainer.length > 0) {
      const container = choicesContainer[0]

      container.classList.forEach(className => {
        if (/^grid-cols-\d+$/.test(className)) {
          container.classList.remove(className)
        }
      })

      container.classList.add(getChoicesClass(gridWidth, maxChoiceLength))
    }
  }, [currentGrila, maxChoiceLength, screenSize, gridWidth])

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension)
    return () => {
      window.removeEventListener('resize', updateDimension)
    }
  }, [screenSize])

  useEffect(() => {
    if (isSubject && gridsFromSubject?.length > 0) {
      setLocalGridsFromSubject(gridsFromSubject)
    }
  }, [gridsFromSubject, isSubject])

  useLayoutEffect(() => {
    if (ref.current) {
      setGridWidth(ref.current.offsetWidth)
    }
  }, [screenSize])

  const isRated = useMemo(() => {
    if (!isSubject) {
      return rated
    }
    const grid = localGridsFromSubject?.[currentGridIndex] ?? {}
    return 'rated' in grid
  }, [isSubject, localGridsFromSubject, currentGridIndex, rated])

  useEffect(() => {
    setModalAfterSubmitOpened(!!answer)
  }, [answer])

  const checkCorrectAnswers = () => {
    let correctCount = 0

    for (let index = 0; index < answer?.correct_answer?.length; index++) {
      if (answer?.correct_answer[index] === gridsFromSubject?.[index]?.choice) {
        correctCount++
      }
    }

    return correctCount
  }
  const numberOfCorrectAnswers = checkCorrectAnswers()
  const subjectResult =
    (numberOfCorrectAnswers * 9) / gridsFromSubject.length + 1

  const getIsPartiallyCorrect = useCallback(() => {
    if (
      answer?.correct_answer === undefined ||
      userChoice === undefined ||
      !isMultipleChoice
    ) {
      return false
    }

    const answerString = String(
      isSubject
        ? answer.correct_answer[currentGridIndex]
        : answer.correct_answer,
    )
    const userChoiceString = String(userChoice)

    for (let index = 0; index < userChoiceString.length; index++) {
      if (answerString.indexOf(userChoiceString[index]) !== -1) {
        return true
      }
    }

    return false
  }, [answer, userChoice, isMultipleChoice, isSubject, currentGridIndex])

  const showTour = useMemo(
    () =>
      !userDetails?.tutorial &&
      !isSubject &&
      !isCreateSubject &&
      !createGrid &&
      currentGrila &&
      !isLoading &&
      started &&
      !isSubmittingGrid,
    [
      userDetails?.tutorial,
      isSubject,
      isCreateSubject,
      createGrid,
      currentGrila,
      isLoading,
      started,
      isSubmittingGrid,
    ],
  )

  const pages = pagesManual || pagesAuto

  const isMobileOrTablet = useMediaQuery({
    query: '(max-width: 1023px)',
  })

  return (
    <div
      className={`lg:relative ${
        widthClass ? widthClass : 'lg:w-[60vw] lg:h-[70svh]'
      } ${
        !noMargin &&
        'mx-auto grid-container items-center w-full md:max-w-[80vw]'
      }
      ${
        (!started || (justStarted && !isLoading)) &&
        'flex items-center justify-center !lg:w-[50vw]'
      }`}
    >
      <div
        className={`z-[100] relative flex justify-center bg-white !bg-primary-background w-full flex-col mx-auto lg:items-center rounded border border-brd-primary 
          ${!answer ? 'overflow-hidden' : 'overflow-visible'}
          ${!started || (justStarted && !isLoading) ? `h-[fit-content] max-w-[780px] ${!isMobileOrTablet ? 'mt-[100px] max-h-[80vh]' : 'mb-[30px]'}` : 'h-[calc(100dvh-70px)]'}
        `}
      >
        {showTour ? <CustomTour isOpen={showTour} /> : null}

        {endTrial || !started ? null : (
          <Header
            isSubmittingSubject={isSubmittingSubject}
            isSubmittingGrid={isSubmittingGrid}
            isSubmitted={isSubmitted}
            isGridSaved={isGridSaved}
            handleSaveGrid={handleSaveGrid}
            handleRemoveSavedGrid={handleRemoveSavedGrid}
            hasHint={hasHint}
            allowHint={allowHint}
            beginTimestamp={beginTimestamp}
            endTimestamp={endTimestamp}
            isCreateSubject={isCreateSubject}
            hint={hintPreview || hint}
            createGrid={createGrid}
            showSkeleton={showSkeleton}
            gridsSidebarOpened={gridsSidebarOpened}
            handleGridsSidebar={handleGridsSidebar}
            isSubject={isSubject}
            isLoading={isLoading}
            currentGrila={
              !isSubject ? currentGrila : gridsFromSubject[currentGridIndex]
            }
            setOpen={setReportModalOpened}
            handleReport={handleReport}
            setOpenInfoModal={setInfoModalOpened}
            difficulty={difficulty}
            handleOpenNoteModal={handleOpenNoteModal}
            handleOpenHintModal={handleOpenHintModal}
            started={started}
            endTrial={endTrial}
            setFilterSettings={setFiltersModalOpened}
            gridTags={formatTags()}
            handleGetRemainingTimeString={handleGetRemainingTimeString}
            isMultipleChoice={isMultipleChoice}
          />
        )}
        <>
          <Content
            isSubmittingGrid={isSubmittingGrid}
            isCreateSubject={isCreateSubject}
            showSkeleton={showSkeleton}
            marginBottomValue={height}
            isLoading={isLoading}
            userChoice={userChoice}
            currentGridIndex={currentGridIndex}
            screenSize={screenSize}
            handleChangeAnswer={handleChangeAnswer}
            handleStartNow={handleStartNow}
            answer={answer}
            currentGrila={currentGrila}
            endTrial={endTrial}
            isSubmitted={isSubmitted}
            isGettingNextGrid={isGettingNextGrid}
            isMultipleChoice={isMultipleChoice}
            refference={ref}
            started={started}
            trialGrileCount={trialGrileCount}
            justStarted={justStarted}
            isSubject={isSubject}
            selectedAnswerIndex={
              isSubject && !isCreateSubject
                ? gridsFromSubject?.[currentGridIndex]?.choice
                : userChoice
            }
            explainAnswers={explainAnswers}
            handleChangeChaptersByCourse={handleChangeChaptersByCourse}
            handleSelectDifficulty={handleSelectDifficulty}
            filterDifficulty={difficultyFilter}
            hasSubscription={hasSubscription}
            filteredTags={filteredTags}
            handleTagsCheckboxChange={handleTagsCheckboxChange}
            grileTypes={grileTypes}
            handleChangeGrileTypes={handleChangeGrileTypes}
            solvingModes={solvingModes}
            handleChangeSolvingMode={handleChangeSolvingMode}
            books={books}
            book={book}
          />
          <ReportModal
            open={reportModalOpened}
            closeModal={closeModal}
            setCheckbox={setCheckbox}
            hint={hint}
            answer={answer}
            handleTextareaChange={handleTextareaChange}
            handleOptionalReport={handleOptionalReport}
          />

          <NoteModal
            isOpened={isNoteModalOpened}
            handleClose={handleCloseNoteModal}
            handleSaveGrid={handleSaveGrid}
            textAreaRef={noteTextAreaRef}
          />

          <HintModal
            hintModalOpened={hintModalOpened}
            hint={hintPreview ? hintPreview : hint}
            handleCloseHintModal={handleCloseHintModal}
          />
          {!isSubject ? (
            <FilterModal
              handleChangeChaptersByCourse={handleChangeChaptersByCourse}
              handleSelectDifficulty={handleSelectDifficulty}
              filterDifficulty={difficultyFilter}
              hasSubscription={hasSubscription}
              filteredTags={filteredTags}
              filterSettings={filtersModalOpened}
              handleTagsCheckboxChange={handleTagsCheckboxChange}
              closeFilterSettings={closeFilterSettings}
              updateFiltersInStorage={updateFiltersInStorage}
              solvingModes={solvingModes}
              handleChangeSolvingMode={handleChangeSolvingMode}
              grileTypes={grileTypes}
              handleChangeGrileTypes={handleChangeGrileTypes}
            />
          ) : null}

          <InfoModal
            pages={pages}
            book={book}
            gridId={gridId}
            source={source}
            openInfoModal={infoModalOpened}
            gridTags={formatTags()}
            gridSubject={gridSubject}
            difficulty={difficulty}
            handleCloseInfoModal={handleCloseInfoModal}
          />
        </>

        {answer && !isLoading ? (
          grilaExplain ? (
            <FooterAfterResponse
              createGrid={createGrid}
              currentGrila={currentGrila}
              isCreateSubject={isCreateSubject}
              setHeight={setHeight}
              handleNewSubjectWindow={handleNewSubjectWindow}
              setRated={setRated}
              subjectLength={gridsFromSubject?.length}
              currentGridIndex={currentGridIndex}
              handlePrevGrid={handlePrevGrid}
              handleNextGrid={handleNextGrid}
              isSubmitted={isSubmitted}
              rated={isRated}
              handleRate={handleRate}
              isSubject={isSubject}
              isCorrect={
                isCreateSubject ||
                isAnswerCorrect(answer?.correct_answer, userChoice) ||
                isAnswerCorrect(
                  answer?.correct_answer?.[currentGridIndex],
                  userChoice,
                )
              }
              isPartialyCorrect={getIsPartiallyCorrect(
                answer?.correctAnswer ||
                  answer?.correct_answer?.[currentGridIndex],
                userChoice,
              )}
              explanation={grilaExplain}
              pages={pages}
              book={book}
              books={books}
              handleUpdateGrid={handleUpdateGrid}
              isActive={!!answer}
              solvingTimePercent={answer?.solvingTimePercent}
            />
          ) : (
            <div className="relative bottom-0 flex items-center z-[100] !bg-container-background border-t border-brd-primary justify-center h-[65px] w-full p-[5px] rounded-bl rounded-br">
              <Button
                className="max-w-[250px] h-[2.7rem] w-[calc(50%-6px)] bg-btn-primary"
                onClick={() => {
                  handleUpdateGrid()
                }}
              >
                Următoarea grilă
              </Button>
            </div>
          )
        ) : null}

        {!started || endTrial || answer ? (
          grilaExplain ? (
            <div className="relative bottom-0 flex items-center z-[100] !bg-container-background border-t border-brd-primary justify-center h-[65px] w-full p-[5px] rounded-bl rounded-br" />
          ) : null
        ) : (
          <FooterBeforeResponse
            showProgress={showProgress}
            isSubmittingGrid={isSubmittingGrid}
            isSubmittingSubject={isSubmittingSubject}
            userChoice={userChoice}
            numberOfAnsweredGrids={numberOfAnsweredGrids}
            subjectLength={gridsFromSubject?.length}
            handleNextGrid={handleNextGrid}
            currentGridIndex={currentGridIndex}
            isSubject={isSubject}
            handleUpdateGrid={handleUpdateGrid}
            endTrial={endTrial}
            answer={answer}
            isLoading={isLoading}
            isAnswerSelected={isAnswerSelected}
            handleSubmit={handleSubmit}
            hasSubscription={hasSubscription}
            currentGrila={currentGrila}
            handlePrevGrid={handlePrevGrid}
            explanation={grilaExplain}
          />
        )}
      </div>

      {/* {false && !isSubject && answer !== null && comments !== undefined && (
        <div className={isSubmitted ? 'fade' : ''}>
          <CommentsSection
            comments={comments}
            grilaId={currentGridId}
            updateCommentsCallback={updateCommentsAfterAddingCommentCallback}
            nrCommentsCurrentUser={comments?.length}
          />
        </div>
      )} */}
      {isSubject && isSmallDevice ? (
        <GridsListModal
          onSuccessCreateSubject={onSuccessCreateSubject}
          isCreateSubject={isCreateSubject}
          isSkippingSubject={isSkippingSubject}
          handleNewSubjectWindow={handleNewSubjectWindow}
          answer={answer}
          handleCloseGridsModal={handleCloseGridsModal}
          gridsSidebarOpened={gridsSidebarOpened}
          gridsFromSubject={gridsFromSubject}
          beginTimestamp={beginTimestamp}
          endTimestamp={endTimestamp}
          content={
            <GridsNavigation
              removeGrid={removeGrid}
              handleCloseGridsModal={handleCloseGridsModal}
              setCurrentSubject={setCurrentSubject}
              handleCurrentGrid={handleCurrentGrid}
              gridsSidebarOpened={gridsSidebarOpened}
              gridsFromSubject={gridsFromSubject}
              answer={answer}
              currentGridIndex={currentGridIndex}
            />
          }
        ></GridsListModal>
      ) : null}
      {isSubject && !subjectCreate ? (
        <ModalAfterSubmit
          subjectLength={gridsFromSubject?.length}
          numberOfCorrectAnswers={numberOfCorrectAnswers}
          subjectResult={subjectResult}
          modalAfterSubmitOpened={modalAfterSubmitOpened}
          handleCloseModalAfterSubmit={handleCloseModalAfterSubmit}
          isGenerated={isSubjectGenerated}
          answer={answer}
        />
      ) : null}
    </div>
  )
}

export default Grid
